
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/invideo-vs-davinci-resolve-color-vs-ai-generated",
      function () {
        return require("private-next-pages/blog/invideo-vs-davinci-resolve-color-vs-ai-generated.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/invideo-vs-davinci-resolve-color-vs-ai-generated"])
      });
    }
  